export const theme = {
  colors: {
    background: '#000000',
    text: '#FFFFFF',
    textSecondary: '#808080',
    primary: '#404040',
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  }
}; 